import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { filter } from 'rxjs/operators';
import { WebsocketService } from '../../services/websocket.service';
import { KioskIdService } from '../../services/kiosk-id.service';

@Component({
  selector: 'app-request',
  templateUrl: './request.component.html',
  styleUrls: ['./request.component.scss']
})
export class RequestComponent implements OnInit {
  form = new FormGroup({
    subject: new FormControl('', [Validators.required]),
    message: new FormControl('', [Validators.required]),
    kiosk: new FormControl(this.kioskIdService.kioskID)
  });

  serverError: string = '';
  processing = false;
  isSend = false;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private websocket: WebsocketService,
    private kioskIdService: KioskIdService
  ) { }

  ngOnInit(): void {
    if (this.route.snapshot.queryParams?.logout) {
      this.websocket.destroy();
      this.authService.logout();
    }

    this.form.valueChanges.pipe(filter(() => !!this.serverError.length)).subscribe(item => {
      this.serverError = '';
    })
  }
  send() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.processing = true;
    const form = this.form.getRawValue();
    this.authService.sendRequest(form).subscribe(req => {
      this.isSend = true;
      this.processing = false;
      console.log(req);
    }, (error: any) => {
      console.error(error);
    });
  }
}
